/* @jsx h */
import { useMutation } from "@tanstack/vue-query";
import { TableStatus } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";
import { defineComponent, ref, h } from "vue";
import { LemmonModal } from "../../components";
import { sanitizeOrderNote } from "@app/utils/clientBusiness";
import { useTrpc } from "@app/vue/providers/index";

export type TablesNotesModalProps = {
  onClose: Function;
  onSuccess: (text: string | null) => void;
  tableStatus: TableStatus;
};
export const TableNotesModal = defineComponent<TablesNotesModalProps>({
  name: "TableNotesModal",
  props: ["onClose", "onSuccess", "tableStatus"],
  setup(props) {
    const { tableStatus } = props;
    const { t } = useLocalization();
    const trpc = useTrpc();
    const isSavingNotes = ref(false);
    const currentNotes = ref<string | undefined>(tableStatus?.party?.name);
    const newNotes = ref(currentNotes.value);
    const savePartyNoteMutation = useMutation({
      mutationFn: (input: { table_id: number; name?: string | null }) =>
        trpc.tables.savePartyNote.mutate(input),
    });
    const saveNotes = async () => {
      console.log(currentNotes.value);
      console.log(newNotes.value);
      if (!tableStatus) return null;
      try {
        isSavingNotes.value = true;
        await savePartyNoteMutation.mutateAsync({
          table_id: tableStatus.id,
          name: newNotes.value || null,
        });
        currentNotes.value = newNotes.value;
        props.onSuccess(newNotes.value || null);
      } catch (e) {
        alert("Failed updating notes");
        props.onClose();
      } finally {
      }
    };
    return () => {
      return (
        <LemmonModal
          title={t("tables.table_notes.title")}
          onClose={() => props.onClose()}
          renderButtons={() => (
            <div class="p-4 border-t ">
              <div class="flex justify-between gap-2">
                <button onClick={() => props.onClose()} class="btn btn-neutral">
                  {t("general.words.cancel")}
                </button>
                <button
                  disabled={
                    newNotes.value == currentNotes.value || isSavingNotes.value
                  }
                  onClick={saveNotes}
                  class="btn btn-primary"
                >
                  {isSavingNotes.value ? (
                    <span class="flex items-center justify-center">
                      <span class="loading loading-spinner loading mr-2"></span>
                    </span>
                  ) : (
                    <span class="flex justify-center items-center">
                      {t("general.words.save")}
                    </span>
                  )}
                </button>
              </div>
            </div>
          )}
        >
          <div class="p-6">
            <label class="form-control w-full">
              <div class="label">
                <span class="label-text text-accent">
                  {t("tables.table_notes.title")}
                </span>
              </div>
              <textarea
                value={newNotes.value}
                onInput={(e) => {
                  const rawValue = (e.target as HTMLTextAreaElement).value;
                  newNotes.value = sanitizeOrderNote(rawValue);
                }}
                class="textarea textarea-bordered h-32 w-full"
                placeholder={t("tables.table_notes.input_placeholder")}
              />
            </label>
          </div>
        </LemmonModal>
      );
    };
  },
});
